export const phoneMenuKey = "phone_menu";
export const searchListKey = "search_list";
